import { Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { applyDirection } from '@/i18n/config'
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import AccessibilityToolbar from '@/components/layout/AccessibilityToolbar'
import ScreenReaderButton from '@/components/layout/ScreenReaderButton'
// import ChatWidget from '@/components/chat/ChatWidget' // hidden: floating GPT chat button
import DiscoveryTour from '@/components/tour/DiscoveryTour'

export default function PublicLayout() {
  const { i18n } = useTranslation()
  const location = useLocation()

  // Ensure direction is set correctly on every route change
  useEffect(() => {
    applyDirection(i18n.language)
  }, [i18n.language, location.pathname])

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <AccessibilityToolbar />
      <ScreenReaderButton position="middle-right" />
      {/* <ChatWidget /> */}
      <DiscoveryTour />
    </div>
  )
}

